import SkeletonInput from 'antd/es/skeleton/Input';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(SkeletonInput);
